/** Role capability copy shown via the Role (i) info icon on user forms. */
export const ROLE_DESCRIPTIONS = {
  corporate_admin:
    'Full access to all users, their settings, branches, and departments across the corporate.',
  admin:
    'Full access to all users, their settings, branches, and departments across the corporate.',
  branch_admin:
    'Similar to Corporate Admin, but limited to the specific branch and its departments.',
  department_admin:
    'Access to users, their settings, and all sub-departments within the department.',
  sub_department_admin:
    'Access to users and their settings for the specific sub-department only.',
  user: 'Standard user access within the assigned organizational scope.',
};

export const ROLE_INFO_SUMMARY =
  'Corporate Admin: all users, settings, branches & departments. Branch Admin: same within the branch. Department Admin: users, settings & sub-departments. Sub Department Admin: users & settings for that sub-department only.';

export function getRoleDescription(roleName) {
  if (!roleName) return ROLE_INFO_SUMMARY;
  const key = String(roleName).toLowerCase().replace(/\s+/g, '_').trim();
  return ROLE_DESCRIPTIONS[key] || ROLE_INFO_SUMMARY;
}
